var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar__month-card-work-icon",class:{ 'work': _vm.item.restType === 2, 'rest': _vm.item.restType === 3 }},[_vm._v("\n    "+_vm._s(_vm.item.restType === 2 ? '班' : '休')+"\n  ")])
}
var staticRenderFns = []

export { render, staticRenderFns }